import { MappingsSettings } from '@components/settings/mappings'

// Admin Tools → Mappings. Thin page shell over the ADAS category mappings table,
// which was built as a settings panel and is fully self-contained (CAR-3778).
export const MappingsPage = () => <MappingsSettings />
